export const DIALOG_CLOSE = 'DIALOG: CLOSE';
export const DIALOG_OPEN = 'DIALOG: OPEN';

export const INIT_DONE = 'INIT: DONE';
export const INIT_ERROR = 'INIT: ERROR';

export const TRANSLATIONS_SET = 'TRANSLATIONS: SET';

export const DEXF_SETTINGS_SET = 'DEXF_SETTINGS_SET';

export const SET_VIEW = 'NAVIGATION: SET_VIEW';

export const POPUPS_HIDE_INTRO_POPUPS = 'POPUPS: HIDE_INTRO_POPUPS';
export const POPUPS_HIDE_SCENE_ERRORS = 'POPUPS: HIDE_SCENE_ERRORS';
export const POPUPS_SHOW_SCENE_ERRORS = 'POPUPS: SHOW_SCENE_ERRORS';
export const POPUPS_CONF_OPEN = 'POPUPS: CONF_OPEN';
export const POPUPS_CONF_CLOSE = 'POPUPS: CONF_CLOSE';
export const POPUPS_CONF_CLEAR = 'POPUPS: CONF_CLEAR';
export const POPUPS_RESET_INTRO = 'POPUPS: RESET_INTRO';
export const POPUPS_SET_HAS_SHOWN_INTRO_POPUPS =
  'POPUPS: SET_HAS_SHOWN_INTRO_POPUPS';
export const POPUPS_MOUNTING_RAIL_SHEET_OPEN =
  'POPUPS: MOUNTING_RAIL_SHEET_OPEN';
export const POPUPS_SUPPLY_BANNER_CLOSE = 'POPUPS: SUPPLY_BANNER_CLOSE';
export const POPUPS_SET_HAS_SHOWN_FILTER_INTRO_POPUP =
  'POPUPS_SET_HAS_SHOWN_FILTER_INTRO_POPUP';
export const POPUPS_SET_FILTER_INTRO_POPUP_VISIBLE =
  'POPUPS_SET_FILTER_INTRO_POPUP_VISIBLE';
export const POPUPS_OVERLAY_ACTIVE = 'POPUPS_OVERLAY_ACTIVE';
export const POPUPS_SCROLL_EXCEPTION = 'POPUPS_SCROLL_EXCEPTION';
export const POPUPS_HANDLE_POPUPS_ON_ADD_ITEM =
  'POPUPS_HANDLE_POPUPS_ON_ADD_ITEM';
export const POPUPS_HANDLE_POPUPS_ON_UPDATE_ITEM =
  'POPUPS_HANDLE_POPUPS_ON_UPDATE_ITEM';
export const POPUPS_SET_INTRO_POPUPS_VISIBLE =
  'POPUPS_SET_INTRO_POPUPS_VISIBLE';
export const POPUPS_SET_CUTTABLE_MOUNTING_RAIL_HINT_CHECK_PENDING =
  'POPUPS_SET_CUTTABLE_MOUNTING_RAIL_HINT_CHECK_PENDING';
export const POPUPS_SET_SURVEY_VISIBLE = 'POPUPS_SET_SURVEY_VISIBLE';
export const POPUPS_SET_SURVEY_STATE = 'POPUPS_SET_SURVEY_STATE';
export const POPUPS_SET_ERROR_HANDLING_PENDING_TIMESTAMP =
  'POPUPS_SET_ERROR_HANDLING_PENDING_TIMESTAMP';

export const SCENE_ITEM_PICKED_UP = 'SCENE: ITEM_PICKED_UP';
export const SCENE_HIDE_MEASUREMENTS = 'SCENE: HIDE_MEASUREMENTS';
export const SCENE_SET_ROOM = 'SCENE: SET_ROOM';
export const SCENE_SET_RECT = 'SCENE: SET_RECT';
export const SCENE_SET_MARGINS = 'SCENE: SET_MARGINS';
export const SCENE_SHOW_MEASUREMENTS = 'SCENE: SHOW_MEASUREMENTS';
export const SCENE_SET_PROPPING_VISIBILITY = 'SCENE: TOGGLE_PROPPING';
export const SCENE_TOGGLE_WALL_RESIZER = 'SCENE: TOGGLE_WALL_RESIZER';
export const SCENE_SET_WALL_RESIZER_ACTIVE = 'SCENE: SET_WALL_RESIZER_ACTIVE';
export const SCENE_SET_PRELOAD_STATE = 'SCENE_SET_PRELOAD_STATE';
export const SCENE_SHOW_SHEET = 'SCENE_SHOW_SHEET';
export const SCENE_HIDE_SHEET = 'SCENE_HIDE_SHEET';
export const SCENE_SET_WALL_RESIZER_INACTIVE =
  'SCENE: SET_WALL_RESIZER_INACTIVE';
export const SCENE_SET_WALL_RESIZER_DRAGGING =
  'SCENE: SET_WALL_RESIZER_DRAGGING';

export const SURVEY_SET_VISIBLE = 'SURVEY_SET_VISIBLE';
export const SURVEY_SET_STATE = 'SURVEY_SET_STATE';

export const VIEW_SET_VIEW_RECT = 'VIEW: SET_VIEW_RECT';

export const SCREENSAVER_MODE = 'SCREENSAVER: MODE';

export const FEATURE_FLAGS_SET = 'FEATURE_FLAGS: SET';

export const STORES_SET = 'STORES: SET';

export const SPRS_SET = 'SPRS: SET';
export const SPRS_SET_RIC = 'SPRS: SET_RIC';

export const PRODUCT_MENU_LOAD_FILTERS = 'PRODUCT_MENU: LOAD_FILTERS';
export const PRODUCT_MENU_SET_FILTER = 'PRODUCT_MENU: SET_FILTER';
export const PRODUCT_MENU_SET_SUB_FILTER = 'PRODUCT_MENU: SET_SUB_FILTER';
export const PRODUCT_MENU_SET_COLOR = 'PRODUCT_MENU: SET_COLOR';
export const PRODUCT_MENU_SET_SUB_FILTER_ITEMS =
  'PRODUCT_MENU: SET_SUB_FILTER_ITEMS';
export const PRODUCT_MENU_CLEAR_FILTER = 'PRODUCT_MENU_CLEAR_FILTER';
export const PRODUCT_MENU_SET_SUB_FILTER_OPTIONS =
  'PRODUCT_MENU_SET_SUB_FILTER_OPTIONS';
export const PRODUCT_MENU_SET_SELECTABLE_COLORS =
  'PRODUCT_MENU_SET_SELECTABLE_COLORS';

export const TAC_ADD_ITEM = 'TAC: ADD_ITEM';
export const TAC_ADD_MULTIPLE = 'TAC: ADD_MULTIPLE';
export const TAC_LOAD = 'TAC: LOAD';
export const TAC_RESET = 'TAC_RESET';
export const TAC_REMOVE_ITEM = 'TAC: REMOVE_ITEM';
export const TAC_HIDE_ITEM = 'TAC: HIDE_ITEM';
export const TAC_UPDATE_ITEM = 'TAC: UPDATE_ITEM';
export const TAC_UPDATE_MULTIPLE = 'TAC: UPDATE_MULTIPLE';
export const TAC_SET_WALL = 'TAC: TAC_SET_WALL';
export const TAC_SET_USE_MOUNTING_RAIL = 'TAC: SET_USE_MOUNTING_RAIL';
export const TAC_REMOVE_TOAST_FLAGS = 'TAC: REMOVE_TOAST_FLAGS';
export const TAC_SET_TOAST_FLAGS = 'TAC: SET_TOAST_FLAGS';
export const TAC_UPDATE_WALL_SIZE = 'TAC: UPDATE_WALL_SIZE';

export const USER_AGENT_UPDATE = 'USER_AGENT_UPDATE';
export const USER_AGENT_UPDATE_HEIGHT = 'USER_AGENT_UPDATE_HEIGHT';
export const USER_AGENT_SHOULD_UPDATE_HEIGHT =
  'USER_AGENT_SHOULD_UPDATE_HEIGHT';

export const VPC_LOADED = 'VPC: VPC_LOADED';
export const VPC_ERROR = 'VPC: ERROR';
export const VPC_CLEAR = 'VPC: CLEAR';
export const VPC_SET_SAVE_STATE = 'VPC_SET_SAVE_STATE';
export const VPC_SET_SAVE_CODE = 'VPC_SET_SAVE_CODE';
export const VPC_DIRTY_CONFIGURATION = 'VPC_DIRTY_CONFIGURATION';
export const VPC_SET_SAVE_PROGRESS_STATUS = 'VPC_SET_SAVE_PROGRESS_STATUS';

export const YMAL_SET = 'YMAL: SET';
export const YMAL_SET_DATA = 'YMAL_SET_DATA';

export const SUMMARY_SET_STORE_AVAILABILITIES =
  'SUMMARY_SET_STORE_AVAILABILITIES';
export const SUMMARY_SET_STORE_ID = 'SUMMARY_SET_STORE_ID';
export const SUMMARY_SET_SHOPPING_ITEMS = 'SUMMARY_SET_SHOPPING_ITEMS';
export const SUMMARY_SET_VPC_CODE = 'SUMMARY_SET_VPC_CODE';
export const SUMMARY_SET_DESIGN_LINK = 'SUMMARY_SET_DESIGN_LINK';
export const SUMMARY_SET_CURRENT_CONFIGURATION =
  'SUMMARY_SET_CURRENT_CONFIGURATION';
export const SUMMARY_SET_STATE = 'SUMMARY_SET_STATE';
export const SUMMARY_SET_SHARE_DESIGN_CARD = 'SUMMARY_SET_SHARE_DESIGN_CARD';
export const SUMMARY_SET_HOME_DELIVERY = 'SUMMARY_SET_HOME_DELIVERY';
export const SUMMARY_SET_FINANCING_OPTIONS = 'SUMMARY_SET_FINANCING_OPTIONS';
export const SUMMARY_SET_MODAL_TYPE = 'SUMMARY_SET_MODAL_TYPE';
export const SUMMARY_SET_SCENE_IMAGE = 'SUMMARY_SET_SCENE_IMAGE';
export const SUMMARY_ADD_UNAVAILABLE_PRODUCTS_TO_LIST =
  'SUMMARY_ADD_UNAVAILABLE_PRODUCTS_TO_LIST';
export const SUMMARY_SET_CONFIRMATION_CARD_TYPE =
  'SUMMARY_SET_CONFIRMATION_CARD_TYPE';
export const SUMMARY_SET_MODAL_STATE = 'SUMMARY_SET_MODAL_STATE';
export const SUMMARY_CLEAR_BUTTON = 'SUMMARY_CLEAR_BUTTON';
export const SUMMARY_SET_COPY_DESIGN_CODE_STATE =
  'SUMMARY_SET_COPY_DESIGN_CODE_STATE';
export const SUMMARY_SET_COPY_DESIGN_LINK_STATE =
  'SUMMARY_SET_COPY_DESIGN_LINK_STATE';
export const SUMMARY_SET_SHOULD_SEND_EVENT_STATE =
  'SUMMARY_SET_SHOULD_SEND_EVENT_STATE';
export const SUMMARY_SET_FAILED_SHOPPING_ITEMS =
  'SUMMARY_SET_FAILED_SHOPPING_ITEMS';

export const SET_RAW_DATA = 'SET_RAW_DATA';

export const SET_RANGE_DATA = 'SET_RANGE_DATA';
export const SET_RANGE_PRODUCT_MENU = 'SET_RANGE_PRODUCT_MENU';

export const SET_DRAFT_CEILING_HEIGHT = 'SET_DRAFT_CEILING_HEIGHT';

export const ENQUEUE_SHEET = 'ENQUEUE_SHEET';
export const DEQUEUE_SHEET = 'DEQUEUE_SHEET';
export const DEQUEUE_ALL_SHEETS = 'DEQUEUE_ALL_SHEETS';

export const TOASTS_SET_HAS_SHOWN_MULTIPACK_MESSAGE_FOR =
  'TOASTS_SET_HAS_SHOWN_MULTIPACK_MESSAGE_FOR';
